import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexGridColumnComponent } from './flex-grid-column.component';
import { FlexGridComponent } from './flex-grid.component';

@NgModule({
  imports: [CommonModule],
  exports: [FlexGridColumnComponent, FlexGridComponent],
  declarations: [FlexGridColumnComponent, FlexGridComponent],
  providers: []
})
export class FlexGridModule {}
